import Asset from 'backbone/platform/models/assets/asset.js'
import BackboneDispatcher from 'lib/backbone_dispatcher.js'

MutlipartUploadState = Object.freeze({
  fileCount: 0,
  uploadCount: 0
})

export default class S3MultipartUploaderView extends Backbone.View
  MAX_FILE_SIZE = 21474836480 # 20 gigabytes
  ACCEPTED_FILE_TYPES = ["video/mp4"]

  events:
    "change": "s3UploadStart"

  initialize: (options) ->
    @fileInputId       = "#" + @$el.attr("id")
    @bucket            = options.bucket
    @dispatcher        = BackboneDispatcher.get_instance()
    @contextData       = options.contextData
    @onProcessingStart = options.onProcessingStart
    @$progressBarClone = $(".s3-upload-progress-wrapper").clone().detach()

    # Intercept drag and drop event from s3_direct_upload form
    $("#s3-uploader").on("fileuploaddrop", @s3UploadStartFromDrop)

  s3UploadStartFromDrop: (event, data) =>
    # Return if drag&drop was meant for another uploader
    pickerForAttr = $("#asset-picker-modal .modal-content-wrapper .dropzone").attr("for")
    return unless pickerForAttr == @fileInputId.substr(1)
    @s3UploadStart(event, event.delegatedEvent.dataTransfer.files)

  s3UploadStart: (event, fileList) ->
    # fileList is defined if this comes from drag&drop
    fileList = if fileList? then fileList else $(@fileInputId).get(0).files
    # Make sure all files are valid before uploading
    return false unless _.every(fileList, @_isValidUpload)

    new S3MP
      bucket: @bucket
      fileInputElement: @fileInputId
      fileList: fileList
      state: @_newUploadState(fileList.length)
      onStart: (upload) =>
        $(@fileInputId).val()
        upload.assetType = @contextData.assetType
        @_buildProgressBar(upload)
        @dispatcher.trigger("s3UploadStart", upload) # closes modal in this case
      onComplete: (upload) =>
        @_saveAsset(upload)
        @_resetProgressBar(upload)
      onError: (err) =>
        @_resetProgressBar(upload)
      onProgress: (num, size, done, percent, speed, upload) =>
        percent = Math.min(+percent.toFixed(2), 100)
        $(".s3-upload-progress-wrapper[dataFileKey=#{@_uidFromUpload(upload)}] .bar").width("#{percent}%")

  _uidFromUpload: (upload) ->
    "#{upload.key}-#{upload.id}"

  _newUploadState: (fileCount) ->
    state = _.clone(MutlipartUploadState)
    state.fileCount = fileCount
    state

  _isValidUpload: (file) =>
    # File size check
    if file.size > MAX_FILE_SIZE
      contently.flash.alert("The file size must be less than 20GB.")
      return false

    # File type check
    if !~ACCEPTED_FILE_TYPES.indexOf(file.type)
      contently.flash.alert(@_fileTypeMessage())
      return false

    true

  _fileTypeMessage: () ->
    typeMsg = switch ACCEPTED_FILE_TYPES.length
      when 1 then ACCEPTED_FILE_TYPES[0]
      when 2 then "#{ACCEPTED_FILE_TYPES[0]}  or #{ACCEPTED_FILE_TYPES[1]}"
      else ACCEPTED_FILE_TYPES.slice(0, -1).join(", ") + "or " + ACCEPTED_FILE_TYPES[ACCEPTED_FILE_TYPES.length - 1]

    typeWrd = if ACCEPTED_FILE_TYPES.length > 1 then "types are" else "type is"

    "The following #{typeWrd} supported: #{typeMsg}"

  _resetProgressBar: (upload) ->
    $("#asset-progress .s3-upload-progress-wrapper[dataFileKey=#{@_uidFromUpload(upload)}]").remove()

  _buildProgressBar: (upload) =>
    $progressBar = @$progressBarClone.clone()
    $progressBar.attr("dataFileKey", @_uidFromUpload(upload))

    # Do this nonsense so we are not totally coupled to s3_direct_upload here
    # This builds the nodes to match the s3_direct_upload progress bar template
    $bar      = $("<div/>").addClass("bar").css("width", "0%")
    $progress = $("<div/>").addClass("progress").append($bar)
    $wrapper  = $("<div/>").addClass("s3-upload-progress").text(upload.name).append($progress)
    $progressBar.append($wrapper)
    $("#asset-progress").append($progressBar)

  _saveAsset: (upload) ->
    upload.state.uploadCount = upload.state.uploadCount + 1

    asset = new Asset(
      assetableType: @contextData.assetableType
      assetType:     @contextData.assetType
      assetableId:   @contextData.assetableId
      relationship:  @contextData.assetType + "_assets"
      fileType:      upload.file.type
      name:          upload.name
      allowDownload: true
      allowDelete:   true
      persisted:     false
      processing:    true
      lastInGroup:   upload.state.fileCount == upload.state.uploadCount
    )
    # lastInGroup is used to determine which AssetView should be opened after 'processing'
    @onProcessingStart(asset)

    # Now create the asset/assetting from the s3 object and return the ID and URL
    $.ajax
      url: asset.url() + "/assetting"
      type: "POST"
      dataType: "json"
      data:
        assetData: @contextData
        s3Key: upload.object_name
      success: (assetData) =>
        asset.set(
          asset_id: assetData.id
          url: assetData.url
          processing: false
          persisted: true
        )

        # Reload asset/activity tab when the last upload in a group is finished
        if asset.get("lastInGroup")
          @dispatcher.trigger("multipartS3UploadsComplete", upload)

        @$el.val("")

      error: =>
        asset.set(processing: false)
        @$el.val("")
        contently.flash.alert("There was an error completing your upload.")



// WEBPACK FOOTER //
// ./app/javascript/backbone/story/views/assets/s3_multipart_uploader_view.js.coffee